// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-transcluscent {\n  background: rgba(100, 100, 100, 0.2);\n}\n", ""]);
// Exports
module.exports = exports;
